import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { StudiosTable, STUDIOS_TABLE_QUERY_KEY } from '@/components/StudiosTable/StudiosTable';
import './StudiosPage.css';

export function StudiosPage() {
  const queryClient = useQueryClient();

  useEffect(() => {
    void queryClient.invalidateQueries({ queryKey: STUDIOS_TABLE_QUERY_KEY });
  }, [queryClient]);

  return (
    <div className="studios-page">
      <div className="studios-page__table-wrap">
        <StudiosTable />
      </div>
    </div>
  );
}
